// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import {
    createActions,
    handleActions
} from 'redux-actions';

export const {
    getCountriesData,
    getCountriesDataSuccess,
    getCountriesDataFail,
} = createActions(
    'GET_COUNTRIES_DATA',
    'GET_COUNTRIES_DATA_SUCCESS',
    'GET_COUNTRIES_DATA_FAIL'
);

export interface CountryType {
    displayCity: string;
    displayState: string;
    displayZipcode: string;
    Id: string;
    ISOCode: string;
    ISOCountryNumber: string;
    ISOCountryShortCode: string;
    ISOName: string;
    ISOType: string;
    optionalZipcode: string;
}

export const INITIAL_COUNTRIES_STATE: {
    list: CountryType[],
    isValid: boolean,
} = {
    list: [],
    isValid: true,
};

export type CountriesDataType = Readonly<typeof INITIAL_COUNTRIES_STATE>;

export default handleActions({
    [getCountriesDataSuccess.toString()]: _getCountriesDataSuccess,
    [getCountriesDataFail.toString()]: _getCountriesDataFail,
}, INITIAL_COUNTRIES_STATE);

function _getCountriesDataSuccess(
    state: any,
    { payload }: { payload: any }
): CountriesDataType {
    if (payload) {
        return {
            ...state,
            list: payload
                .filter((country: CountryType) => {
                    return country.ISOType.toLowerCase() === 'country';
                })
                .sort((country1: CountryType, country2: CountryType) => country1.ISOName > country2.ISOName ? 1 : -1),
        };
    }

    return INITIAL_COUNTRIES_STATE;
}

function _getCountriesDataFail(state: any) {
    return { ...state };
}
